module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrCodeScan"
  }, [_c('canvas', {
    ref: "qr",
    style: ({
      height: _vm.size + '%',
      width: _vm.size + '%'
    }),
    attrs: {
      "height": _vm.size,
      "width": _vm.size,
      "val": _vm.val
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62349cff","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/qrCode/src/qrCode.vue
// module id = 538
// module chunks = 0